import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app.routes";
import { AppComponent } from "./app.component";
import { BASE_API_URL, baseHttpRequestInterceptor } from "../../../shared/_interceptors/base-http-request.interceptor";
import { PendingRequestInterceptor } from "../../../shared/_interceptors/pending-http-request.interceptor";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatDialogModule } from "@angular/material/dialog";
import { LoaderComponent } from "../../../shared/_components/loader/loader.component";

import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { ToastrModule } from "ngx-toastr";
import { NotificationsService } from "../../../shared/_services/notifications.service";
import { ADMIN_APP_URL } from "./_shared/services/admin-app.service";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

import { environment } from "../environments/environment";
import { ErrorHandlerService } from "../../../shared/_services/error-handler.service";
import { ErrorDialogComponent } from "./_components/error-dialog/error-dialog.component";
import { GeneralErrorHandlerService } from "./_shared/services/general-error-handler.service";
import { MatButtonModule } from "@angular/material/button";
import { GOOGLE_CLIENT_ID } from "./auth/auth.component";
import { ThemeService } from "../../../shared/_services/theme.service";

@NgModule({
    declarations: [AppComponent, ErrorDialogComponent],
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        BrowserAnimationsModule, // required animations module
        LoaderComponent,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: "toast-bottom-right",
            preventDuplicates: true,
            closeButton: true,
            tapToDismiss: true,
            maxOpened: 3,
        }), // ToastrModule added
    ],
    providers: [
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: "/assets/i18n/",
                suffix: ".json",
            }),
            fallbackLang: "en",
        }),
        provideHttpClient(withInterceptors([baseHttpRequestInterceptor()]), withInterceptorsFromDi()),
        PendingRequestInterceptor,
        ErrorHandlerService,
        NotificationsService,
        ThemeService,
        {
            provide: HTTP_INTERCEPTORS,
            useExisting: PendingRequestInterceptor,
            multi: true,
        },
        { provide: BASE_API_URL, useValue: environment.apiUrl },
        { provide: ADMIN_APP_URL, useValue: environment.adminUrl },
        { provide: GOOGLE_CLIENT_ID, useValue: environment.googleClientID },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: "outline" } },
        GeneralErrorHandlerService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
